// 初期表示
export const PAGE_INIT = "corp/csr/governance/PAGE_INIT";
// コーポレートガバナンス報告書データ取得（初期表示）
export const REPORT_GET = "corp/csr/governance/REPORT_GET";
